import styled, { createGlobalStyle } from 'styled-components'
import { Button } from 'antd'

import ContentBlockWrapper from '../../components/ContentBlockWrapper'

export const ItemBg = styled.div`
  background: #ffffff;
  padding: 28px 32px;
  width: 100%;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.04), 0 1px 3px rgba(15, 23, 42, 0.02);
  border: 1px solid #e2e8f0;
  border-radius: 16px;
`

export const ItemSubject = styled.h1`
  font-family: "Inter", Noto Sans Display, sans-serif !important;
  font-weight: 400 !important;
  font-size: 24px !important;
  line-height: 32px !important;
  color: #0f172a;
  letter-spacing: -0.01em;
  margin: 0;
`

export const ItemContent = styled.div`
  font-size: 14px !important;
  line-height: 1.7;
  color: #334155;

  figure img,
  img {
    max-width: 100%;
    border-radius: 8px;
  }
`

export const TinTucPageWrapper = styled.div`
  font-family: "Inter", Noto Sans Display, sans-serif !important;

  .news-page-heading {
    display: inline-block;
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
    color: #0f172a;
    font-family: "Inter", Noto Sans Display, sans-serif !important;
    letter-spacing: -0.01em;
    margin: 0;
  }
`

export const TinTucContentWrapper = styled.div`
  padding: 16px 0 24px;
  background: transparent;
  width: 100%;
  font-family: "Inter", Noto Sans Display, sans-serif !important;

  .ant-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 240px;
    margin: 0 auto;
    padding: 32px 0;

    .ant-empty-image {
      height: 44px;
      margin: 0 0 10px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      opacity: 0.75;
      filter: grayscale(1);

      svg {
        width: auto;
        height: 40px;
        opacity: 0.8;
      }
    }

    .ant-empty-description {
      margin: 0;
      padding: 0;
      color: #94a3b8 !important;
      font-family: "Inter", Noto Sans Display, sans-serif !important;
      font-size: 14px !important;
      font-weight: 400 !important;
      line-height: 20px !important;
      text-align: center;
    }
  }
`

export const TinTucCreateButton = styled(Button)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 38px !important;
  padding: 0 16px !important;
  border-radius: 8px !important;
  background-color: #1d68a5 !important;
  border-color: #1d68a5 !important;
  background: #1d68a5 !important;
  color: #ffffff !important;
  font-family: "Inter", Noto Sans Display, sans-serif !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  box-shadow: 0 2px 8px rgba(29, 104, 165, 0.2) !important;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;

  &:hover,
  &:focus {
    background-color: #155589 !important;
    border-color: #155589 !important;
    background: #155589 !important;
    color: #ffffff !important;
    box-shadow: 0 4px 12px rgba(29, 104, 165, 0.3) !important;
  }

  &:active {
    transform: scale(0.98);
  }

  .anticon {
    font-size: 15px !important;
  }
`

export const TinTucMasterDetailLayout = styled.section`
  display: grid;
  grid-template-columns: 300px minmax(0, 1fr);
  gap: 24px;
  width: 100%;
  min-width: 0;
  align-items: start;
  font-family: "Inter", Noto Sans Display, sans-serif !important;

  @media (max-width: 991px) {
    grid-template-columns: 1fr;
  }
`

export const TinTucListPanel = styled.aside`
  min-width: 0;
  width: 100%;
`

export const TinTucList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 78vh;
  overflow-y: auto;
  padding-right: 4px;

  &::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: #e2e8f0;
    border-radius: 9999px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #cbd5e1;
  }

  @media (max-width: 991px) {
    max-height: 350px;
  }
`

export const TinTucListItem = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-height: 64px;
  padding: 12px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  text-align: left;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.02);
  font-family: "Inter", Noto Sans Display, sans-serif !important;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;

  &:hover {
    border-color: #bae6fd;
    background: #f8fafc;
    box-shadow: 0 4px 12px rgba(112, 174, 251, 0.1);
    transform: translateX(2px);

    .news-list-author {
      color: #0f172a;
    }
  }

  &:focus {
    outline: none;
  }

  &.active {
    border-color: #9cd4fc;
    background: #eff8ff;
    box-shadow: 0 4px 14px rgba(112, 174, 251, 0.14);
    transform: none;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 3.5px;
      background: #70aefb;
      border-top-left-radius: 7px;
      border-bottom-left-radius: 7px;
    }

    .news-list-author {
      color: #0f172a;
      font-weight: 600;
    }

    .news-list-subject {
      color: #1e293b;
      font-weight: 500;
    }
  }

  .news-list-avatar {
    flex: 0 0 38px;
    width: 38px;
    height: 38px;
    line-height: 38px;
    border-radius: 50%;
    background: #70aefb;
    color: #ffffff;
    font-size: 15px;
    font-weight: 600;
    box-shadow: 0 2px 6px rgba(112, 174, 251, 0.22);
  }

  .news-list-text {
    min-width: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 3px;
  }

  .news-list-top-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    min-width: 0;
  }

  .news-list-author {
    color: #0f172a;
    font-size: 14px !important;
    font-weight: 500;
    line-height: 18px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-transform: capitalize;
    transition: color 0.2s ease;
  }

  .news-list-date {
    color: #94a3b8;
    font-size: 14px !important;
    font-weight: 400;
    white-space: nowrap;
    flex-shrink: 0;
  }

  .news-list-subject {
    color: #475569;
    font-size: 14px !important;
    line-height: 18px;
    font-weight: 400;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    transition: color 0.2s ease;
  }
`

export const TinTucDetailShell = styled.main`
  flex: 1 1 auto;
  min-width: 0;
  padding: 16px;
  border-radius: 16px;
  background: #f6f6f6;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.03);
  font-family: "Inter", Noto Sans Display, sans-serif !important;

  @media (max-width: 991px) {
    padding: 12px;
  }
`

export const TinTucDetailCard = styled.article`
  min-height: 74vh;
  max-height: 74vh;
  overflow: hidden;
  padding: 0;
  border-radius: 12px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.04), 0 1px 3px rgba(15, 23, 42, 0.02);
  position: relative;
  display: flex;
  flex-direction: column;
  font-family: "Inter", Noto Sans Display, sans-serif !important;

  @media (max-width: 991px) {
    min-height: auto;
    max-height: none;
    overflow: visible;
  }

  .news-detail-header-fixed {
    flex-shrink: 0;
    padding: 24px 32px 18px;
    background: #ffffff;
    border-bottom: 1px solid #f1f5f9;
    position: sticky;
    top: 0;
    z-index: 10;
  }

  .news-detail-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
  }

  .news-detail-header-left {
    min-width: 0;
    flex: 1;
  }

  .news-detail-subject {
    min-width: 0;
    margin: 0;
    color: #0f172a;
    font-family: "Inter", Noto Sans Display, sans-serif !important;
    font-size: 24px !important;
    line-height: 32px !important;
    font-weight: 400 !important;
    letter-spacing: -0.01em;
    word-break: break-word;
  }

  .news-detail-meta {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 16px;
    margin-top: 10px;
    color: #64748b;
    font-size: 14px !important;
  }

  .news-detail-meta-item {
    display: inline-flex;
    align-items: center;
    gap: 6px;

    .anticon {
      color: #70aefb;
      font-size: 13.5px;
    }

    .meta-author-avatar {
      background: #70aefb;
      color: #ffffff;
      font-size: 12px;
      font-weight: 600;
      border-radius: 50%;
      box-shadow: 0 1px 4px rgba(112, 174, 251, 0.22);
    }

    .meta-author-name {
      font-weight: 600;
      color: #334155;
      text-transform: capitalize;
    }
  }

  .news-detail-menu-btn {
    flex: 0 0 auto;
    width: 36px;
    height: 36px;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    background: #ffffff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #64748b;
    font-size: 16px;
    cursor: pointer;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    outline: none !important;

    &:hover,
    &.ant-dropdown-open,
    &:focus-visible {
      background: #eff8ff;
      border-color: #9cd4fc;
      color: #0f172a;
      box-shadow: 0 2px 8px rgba(112, 174, 251, 0.16);
    }
  }

  .news-detail-divider {
    border: none;
    border-top: 1px solid #f1f5f9;
    margin: 18px 0 22px;
  }

  .news-detail-body {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 22px 32px 28px;

    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: #e2e8f0;
      border-radius: 9999px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #cbd5e1;
    }

    @media (max-width: 991px) {
      padding: 16px 18px 20px;
    }
  }

  .news-detail-content {
    min-width: 0;
    color: #334155;
    font-size: 14.5px;
    line-height: 1.75;
    word-break: break-word;

    h1, h2, h3, h4, h5, h6 {
      color: #0f172a;
      font-weight: 700;
      margin-top: 22px;
      margin-bottom: 10px;
    }

    h1 {
      font-size: 20px;
      line-height: 28px;
    }

    h2 {
      font-size: 18px;
      line-height: 26px;
    }

    h3 {
      font-size: 16px;
      line-height: 24px;
    }

    p {
      margin-bottom: 12px;
    }

    ul, ol {
      padding-left: 24px;
      margin-bottom: 16px;

      li {
        margin-bottom: 6px;
        line-height: 1.65;
      }
    }

    figure,
    img {
      max-width: 100%;
      border-radius: 8px;
      margin: 14px 0;
    }
  }

  .news-attachments {
    margin-top: 32px;
    padding-top: 20px;
    border-top: 1px dashed #e2e8f0;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .news-attachments-header {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #0f172a;
    font-size: 14px;
    font-weight: 600;

    .anticon {
      color: #70aefb;
      font-size: 16px;
    }

    .attachments-count {
      display: inline-flex;
      align-items: center;
      padding: 1px 8px;
      border-radius: 6px;
      background: #eff8ff;
      color: #475569;
      font-size: 14px !important;
      font-weight: 400 !important;
    }
  }

  .news-attachments-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    min-width: 0;
  }
`

export const TinTucPaginationWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 18px 0 0;
  font-family: "Inter", Noto Sans Display, sans-serif !important;

  .ant-pagination-item,
  .ant-pagination-prev,
  .ant-pagination-next {
    border-radius: 8px !important;
    border-color: #e2e8f0;

    &:hover {
      border-color: #9cd4fc;
      a {
        color: #70aefb;
      }
    }
  }

  .ant-pagination-item-active {
    background-color: #eff8ff !important;
    border-color: #9cd4fc !important;

    a {
      color: #0f172a !important;
      font-weight: 600 !important;
    }
  }
`

export const TinTucDropdownGlobalStyle = createGlobalStyle`
  .news-action-dropdown {
    font-family: "Inter", Noto Sans Display, sans-serif !important;

    .ant-dropdown-menu {
      border-radius: 12px !important;
      padding: 6px !important;
      border: 1px solid #eef2f6 !important;
      box-shadow: 0 10px 25px -5px rgba(15, 23, 42, 0.12), 0 8px 10px -6px rgba(15, 23, 42, 0.08) !important;
      background: #ffffff !important;
      min-width: 155px !important;
      font-family: "Inter", Noto Sans Display, sans-serif !important;
    }

    .ant-dropdown-menu-item {
      border-radius: 8px !important;
      padding: 10px 14px !important;
      font-size: 14px !important;
      font-weight: 500 !important;
      font-family: "Inter", Noto Sans Display, sans-serif !important;
      display: flex !important;
      align-items: center !important;
      gap: 10px !important;
      transition: all 0.15s ease !important;
      color: #334155 !important;
      margin-bottom: 2px !important;

      &:last-child {
        margin-bottom: 0 !important;
      }

      .anticon {
        font-size: 15px !important;
      }

      &:hover {
        background: #f1f5f9 !important;
        color: #0f172a !important;
      }

      &.menu-item-view {
        color: #334155 !important;
        .anticon {
          color: #64748b !important;
        }
        &:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          .anticon {
            color: #70aefb !important;
          }
        }
      }

      &.menu-item-edit {
        color: #0f172a !important;
        .anticon {
          color: #70aefb !important;
        }
        &:hover {
          background: #eff8ff !important;
          color: #0f172a !important;
        }
      }

      &.menu-item-danger,
      &.ant-dropdown-menu-item-danger {
        color: #ef4444 !important;
        .anticon {
          color: #ef4444 !important;
        }
        &:hover {
          background: #fef2f2 !important;
          color: #dc2626 !important;
        }
      }
    }
  }

  .news-delete-confirm-modal {
    .ant-modal-content {
      border-radius: 16px !important;
      overflow: hidden !important;
      box-shadow: 0 20px 40px -8px rgba(15, 23, 42, 0.2) !important;
      border: 1px solid #eef2f6 !important;
    }

    .ant-modal-confirm-body {
      padding: 24px 24px 20px !important;
    }

    .ant-modal-confirm-title {
      font-size: 16px !important;
      font-weight: 700 !important;
      color: #0f172a !important;
    }

    .ant-modal-confirm-btns {
      padding: 0 24px 20px !important;
      display: flex !important;
      justify-content: flex-end !important;
      gap: 10px !important;

      .ant-btn {
        height: 38px !important;
        border-radius: 8px !important;
        padding: 0 18px !important;
        font-size: 14px !important;
        font-weight: 500 !important;
      }

      .ant-btn-danger {
        background-color: #ef4444 !important;
        border-color: #ef4444 !important;
        color: #ffffff !important;
        font-weight: 600 !important;
        box-shadow: 0 2px 6px rgba(239, 68, 68, 0.25) !important;

        &:hover, &:focus {
          background-color: #dc2626 !important;
          border-color: #dc2626 !important;
        }
      }
    }
  }
`
